import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'isObjectHasValues',
})
export class CheckObjectValuesPipe implements PipeTransform {
  constructor() {}

  transform(list: object): boolean {
    const values: any[] = Object.values(list);
    return values.every((item) => !item);
  }
}
